import React from 'react'
import './Info.css'
import Footer from '../UIElements/Footer'
import HomeHomeNavigation from './HomeHomeNavigation'

import MPBHC_BYLAWS from './../../../../src/meetingMinutes/MPBHC_BYLAWS.docx.pdf'
import USABH_RULE_BOOK from './../../../../src/meetingMinutes/USA-Ball-Hockey-Official-Rule-Book-Revised-01.14.2021.pdf'

import Dec2025 from './../../../../src/meetingMinutes/Meeting Minutes December 2025.pdf'
import Nov2025 from './../../../../src/meetingMinutes/Meeting Minutes November 2025.pdf'
import Sept2025 from './../../../../src/meetingMinutes/Meeting Minutes September 2025.pdf'
import Aug2025 from './../../../../src/meetingMinutes/Meeting Minutes August 2025.pdf'
import July2025 from './../../../../src/meetingMinutes/Meeting Minutes July 2025.pdf'
import June2025 from './../../../../src/meetingMinutes/MPBHC June Meeting Minutes.pdf'
import May2025 from './../../../../src/meetingMinutes/Meeting Minutes 5_5_25.pdf'

const InfoRow = ({ href, title, subtitle }) => {
	return (
		<a className='infoRow' href={href} target='_blank' rel='noreferrer'>
			<div className='infoRowLeft'>
				<div className='infoIcon' aria-hidden='true'>
					{/* Doc icon */}
					<svg viewBox='0 0 24 24' width='22' height='22'>
						<path
							fill='currentColor'
							d='M6 2h8l4 4v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm8 1.5V7h3.5L14 3.5zM7 11h10v2H7v-2zm0 4h10v2H7v-2z'
						/>
					</svg>
				</div>

				<div className='infoRowText'>
					<div className='infoRowTitle'>{title}</div>
					{subtitle ? <div className='infoRowSubtitle'>{subtitle}</div> : null}
				</div>
			</div>

			<div className='infoChevron' aria-hidden='true'>
				<svg viewBox='0 0 24 24' width='22' height='22'>
					<path fill='currentColor' d='M9 6l6 6-6 6' />
				</svg>
			</div>
		</a>
	)
}

const InfoSection = ({ label, children }) => {
	return (
		<div className='infoSection'>
			<div className='infoSectionHeader'>
				<div className='infoSectionLabel'>{label}</div>
				<div className='infoSectionRule' />
			</div>
			<div className='infoCard'>{children}</div>
		</div>
	)
}

const Info = () => {
	const officialDocs = [
		{ href: MPBHC_BYLAWS, title: 'BY-LAWS', subtitle: 'MPBHC by-laws' },
		{
			href: USABH_RULE_BOOK,
			title: 'USA Ball Hockey Official Rule Book',
			subtitle: 'Governing body rules',
		},
	]

	const meetingMinutesByYear = {
		2025: [
			{ href: Dec2025, title: 'Meeting Minutes', subtitle: 'December 2025' },
			{ href: Nov2025, title: 'Meeting Minutes', subtitle: 'November 2025' },
			{ href: Sept2025, title: 'Meeting Minutes', subtitle: 'September 2025' },
			{ href: Aug2025, title: 'Meeting Minutes', subtitle: 'August 2025' },
			{ href: July2025, title: 'Meeting Minutes', subtitle: 'July 2025' },
			{ href: June2025, title: 'Meeting Minutes', subtitle: 'June 2025' },
			{ href: May2025, title: 'Meeting Minutes', subtitle: 'May 5, 2025' },
		],
	}

	return (
		<div className='infoPage'>
			<HomeHomeNavigation />

			{/* centered column */}
			<div className='infoContent'>
				<InfoSection label='OFFICIAL DOCUMENTS'>
					{officialDocs.map((d) => (
						<InfoRow
							key={d.title}
							href={d.href}
							title={d.title}
							subtitle={d.subtitle}
						/>
					))}
				</InfoSection>

				<InfoSection label='MEETING MINUTES'>
					{Object.keys(meetingMinutesByYear)
						.sort((a, b) => Number(b) - Number(a))
						.map((year) => (
							<div key={year} className='infoYearBlock'>
								<div className='infoYearLabel'>{year}</div>
								<div className='infoYearList'>
									{meetingMinutesByYear[year].map((m) => (
										<InfoRow
											key={`${year}-${m.subtitle}`}
											href={m.href}
											title={m.title}
											subtitle={m.subtitle}
										/>
									))}
								</div>
							</div>
						))}
				</InfoSection>
			</div>

			{/* full-width footer */}
			<Footer />
		</div>
	)
}

export default Info
